import {
  COMMERCIAL,
  ENGINEERING_NETWORKS,
  FURNISHING_SUPERVISOR,
  HEAD_EN,
  HEAD_OVP,
  OBSERVER,
  PARTNER,
  PLANNER,
  PRIME_CONTRACTOR,
  HOUSING_CONTRACTOR,
  ROUTES,
  SUPERVISOR,
  USK_PRE_ACCEPTANCE,
} from 'consts';

// *
// **
// Тут указываются к каким страницам у пользователя есть доступ.
// Т.e. даже если в урл вставить путь до компонента (страницы) к
// которому у юзера нету доступа будет ошибка и компонент не отрисуется
// **
// *
const COMMERCIAL_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.CALLS.ROOT,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ...Object.values(ROUTES.PLAN),
  ROUTES.PLAN.NEW_ENGINEERING,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.ROOT,
  ROUTES.SETTING.APARTMENTS,
  ...Object.values(ROUTES.ANALYTICS),
  ...Object.values(ROUTES.DELIVERY_SCHEDULE),
  ROUTES.UPDATES.ROOT,
];

const ENGINEERING_NETWORKS_ROUTES = [
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.CALLS.ROOT,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_MY_CALLS,
  ROUTES.CALLS.ENG_NETWORKS_MY_CALLS_ID,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ...Object.values(ROUTES.PLAN).filter(plan => plan !== ROUTES.PLAN.PLACEMENTS),
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.DOCUMENTS.ROOT,
  ROUTES.ANALYTICS.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.UPDATES.ROOT,
];

const FURNISHING_SUPERVISOR_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.UPDATES.ROOT,
];

const HEAD_EN_ROUTES = [
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.CALLS.ROOT,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_MY_CALLS,
  ROUTES.CALLS.ENG_NETWORKS_MY_CALLS_ID,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ...Object.values(ROUTES.PLAN).filter(page => page !== ROUTES.PLAN.PLACEMENTS),
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.SETTING.ENG_NET_BY_OBJECT,
  ROUTES.SETTING.ENG_NET_BY_PROJECT,
  ROUTES.DOCUMENTS.ROOT,
  ROUTES.ANALYTICS.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.UPDATES.ROOT,
];

const HEAD_OVP_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.CALLS.ROOT,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ...Object.values(ROUTES.PLAN),
  ROUTES.PLAN.NEW_ENGINEERING,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.ROOT,
  ROUTES.SETTING.APARTMENTS,
  ...Object.values(ROUTES.ANALYTICS),
  ...Object.values(ROUTES.DELIVERY_SCHEDULE),
  ROUTES.UPDATES.ROOT,
];

const OBSERVER_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.CALLS.ROOT,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ...Object.values(ROUTES.UPLOADING_PLAN),
  ...Object.values(ROUTES.PLAN),
  ROUTES.PLAN.NEW_ENGINEERING,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.APARTMENTS,
  ROUTES.SETTING.ENG_NET_BY_OBJECT,
  ROUTES.SETTING.ENG_NET_BY_PROJECT,
  ...Object.values(ROUTES.ANALYTICS),
  ...Object.values(ROUTES.DELIVERY_SCHEDULE),
  ROUTES.UPDATES.ROOT,
];

const PARTNER_ROUTES = [ROUTES.APARTMENT_LIST.ROOT, ROUTES.UPDATES.ROOT];

const PLANNER_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ...Object.values(ROUTES.PLAN),
  ...Object.values(ROUTES.UPLOADING_PLAN),
  // ROUTES.UPLOADING_PLAN.ENGINEERING_NETWORKS,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.UPDATES.ROOT,
  ...Object.values(ROUTES.DELIVERY_SCHEDULE),
];

// TODO Доработка для // accountingType === IZS ? { menuItem: 'placementsStatus' } : { menuItem: 'apartmentStatus' },
const PRIME_CONTRACTOR_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.CALLS.ROOT,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ...Object.values(ROUTES.PLAN),
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.ANALYTICS.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
  ...Object.values(ROUTES.DELIVERY_SCHEDULE),
  ROUTES.UPDATES.ROOT,
  // TODO - FP
  '/feature-packages/apartmentsStatus',
];

const HOUSING_CONTRACTOR_ROUTES = [ROUTES.PLACEMENTS_STATUS.ROOT];

const USK_PRE_ACCEPTANCE_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.UPDATES.ROOT,
];

const SUPERVISOR_ROUTES = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.DEFECTS.ROOT,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ...Object.values(ROUTES.UPLOADING_PLAN),
  ...Object.values(ROUTES.PLAN),
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.APARTMENTS,
  ROUTES.SETTING.ENG_NET_BY_OBJECT,
  ROUTES.SETTING.ENG_NET_BY_PROJECT,
  ROUTES.ANALYTICS.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
  ROUTES.ANALYTICS.REPORTING_OVP,
  ROUTES.ANALYTICS.APARTMENT_STATUS,
  ...Object.values(ROUTES.DELIVERY_SCHEDULE),
  ROUTES.UPDATES.ROOT,
];

// Разрешенные роуты для ролей
export const ROLE_ROUTES_PERMISSIONS = {
  [COMMERCIAL]: COMMERCIAL_ROUTES,
  [ENGINEERING_NETWORKS]: ENGINEERING_NETWORKS_ROUTES,
  [FURNISHING_SUPERVISOR]: FURNISHING_SUPERVISOR_ROUTES,
  [HEAD_EN]: HEAD_EN_ROUTES,
  [HEAD_OVP]: HEAD_OVP_ROUTES,
  [OBSERVER]: OBSERVER_ROUTES,
  [PARTNER]: PARTNER_ROUTES,
  [PLANNER]: PLANNER_ROUTES,
  [PRIME_CONTRACTOR]: PRIME_CONTRACTOR_ROUTES,
  [HOUSING_CONTRACTOR]: HOUSING_CONTRACTOR_ROUTES,
  [USK_PRE_ACCEPTANCE]: USK_PRE_ACCEPTANCE_ROUTES,
  [SUPERVISOR]: SUPERVISOR_ROUTES,
};
